import { render, staticRenderFns } from "./JVDocument.vue?vue&type=template&id=656ef4eb&scoped=true&"
import script from "./JVDocument.vue?vue&type=script&lang=js&"
export * from "./JVDocument.vue?vue&type=script&lang=js&"
import style0 from "./JVDocument.vue?vue&type=style&index=0&id=656ef4eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ef4eb",
  null
  
)

export default component.exports